import React, { useContext } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { ServiciosContext } from "../../context/ServiciosContext";

const columnasPai = [
  ["paiObjetivos", "Objetivo"],
  ["paiAcciones", "Acción o intervención"],
  ["paiPeriodicidades", "Periodicidad"],
  ["paiResponsables", "Responsable"],
];

export default function PAI() {
  const { selectedRowPaciente, examenIII, guardarExamenIII } =
    useContext(ServiciosContext);

  const leerFilas = (campo) => {
    const valor = examenIII?.[campo];
    if (Array.isArray(valor)) return [...valor];
    if (!valor) return [];

    try {
      const filas = JSON.parse(valor);
      return Array.isArray(filas) ? filas : [];
    } catch (error) {
      return [];
    }
  };

  const actualizarCampo = (campo, valor) => {
    guardarExamenIII({ ...examenIII, [campo]: valor });
  };

  const actualizarFila = (campo, index, valor) => {
    const filas = leerFilas(campo);
    filas[index] = valor;
    actualizarCampo(campo, JSON.stringify(filas));
  };

  return (
    <Grid container spacing={2} style={{ marginTop: "1rem" }}>
      <Grid item xs={12}>
        <Typography variant="h6" style={{ textDecoration: "underline" }}>
          Plan de Atención Integral
        </Typography>
      </Grid>

      <Grid item xs={12} md={8}>
        <TextField
          fullWidth
          label="Nombre y apellido de la persona residente"
          value={selectedRowPaciente?.nombre || ""}
          variant="standard"
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          type="date"
          label="Fecha"
          value={examenIII?.paiFecha || ""}
          onChange={(event) => actualizarCampo("paiFecha", event.target.value)}
          variant="standard"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Fecha de ingreso a la residencia"
          value={selectedRowPaciente?.fechaIngresoEgreso?.slice(0, 10) || ""}
          variant="standard"
          InputProps={{ readOnly: true }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          type="date"
          label="Fecha de aplicación de la VGI"
          value={examenIII?.paiFechaAplicacionVgi || ""}
          onChange={(event) =>
            actualizarCampo("paiFechaAplicacionVgi", event.target.value)
          }
          variant="standard"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "minmax(180px, 1fr) minmax(240px, 1.5fr) minmax(130px, .7fr) minmax(160px, .8fr)",
            minWidth: "780px",
            borderTop: "1px solid #bdbdbd",
            borderLeft: "1px solid #bdbdbd",
          }}
        >
          {[
            "Objetivos",
            "Acciones e intervenciones",
            "Periodicidad",
            "Responsable",
          ].map((titulo) => (
            <div
              key={titulo}
              style={{
                padding: "10px 8px",
                borderRight: "1px solid #bdbdbd",
                borderBottom: "1px solid #bdbdbd",
                background: "#f5f5f5",
                fontWeight: "bold",
              }}
            >
              {titulo}
            </div>
          ))}

          {Array.from({ length: 5 }, (_, index) =>
            columnasPai.map(([campo, etiqueta]) => (
              <div
                key={`${campo}-${index}`}
                style={{
                  padding: "6px 8px",
                  borderRight: "1px solid #bdbdbd",
                  borderBottom: "1px solid #bdbdbd",
                  minHeight: "76px",
                }}
              >
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  aria-label={`${etiqueta} ${index + 1}`}
                  value={leerFilas(campo)[index] || ""}
                  onChange={(event) =>
                    actualizarFila(campo, index, event.target.value)
                  }
                  variant="standard"
                />
              </div>
            ))
          )}
        </div>
      </Grid>

    </Grid>
  );
}